import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import logo from './parentalRights.png'; 
import { Link } from 'react-router-dom';


function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar sx={{ backgroundColor: "white" }} position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
            <Box
                component="img"
                sx={{mr: 2, height: 40,  display: { xs: 'none', sm: 'none', md: 'inherit' } }}
                alt="Your logo."
                src={logo}
            />          
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="menu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="black"
            >
            <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                 display: { xs: 'block', md: 'none' },
              }}
            >

              <MenuItem onClick={handleCloseNavMenu}>
                <Link to="/" style={{ textDecoration: 'none' }}>
                  <Typography textAlign="center" sx={{ color: 'black'}}>
                      Home
                  </Typography>
                </Link>
              </MenuItem>
              <MenuItem onClick={handleCloseNavMenu}>
                <Link to="/Story" style={{ textDecoration: 'none' }}>
                  <Typography textAlign="center" sx={{ color: 'black'}}>
                      Our Story
                  </Typography>
                </Link>
              </MenuItem>
              <MenuItem onClick={handleCloseNavMenu}>
                <Link to="https://www.ArtClubMovie.com" target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                  <Typography textAlign="center" sx={{ color: 'black'}}>
                      Documentary
                  </Typography>
                </Link>
              </MenuItem>  
              <MenuItem onClick={handleCloseNavMenu}>
                <Link to="/Resources" style={{ textDecoration: 'none' }}>
                  <Typography textAlign="center" sx={{ color: 'black'}}>
                      Resources
                  </Typography>
                </Link>
              </MenuItem>
              <MenuItem onClick={handleCloseNavMenu}>
                <Link to="/RapidOnset" style={{ textDecoration: 'none' }}>
                  <Typography textAlign="center" sx={{ color: 'black'}}>
                    ROGD
                  </Typography>
                </Link>
              </MenuItem>  
              <MenuItem onClick={handleCloseNavMenu}>
                <Link to="/Connect" style={{ textDecoration: 'none' }}>
                  <Typography textAlign="center" sx={{ color: 'black'}}>
                    Connect
                  </Typography>
                </Link>
              </MenuItem> 
              <MenuItem onClick={handleCloseNavMenu}>
                <Link to="/About" style={{ textDecoration: 'none' }}>
                  <Typography textAlign="center" sx={{ color: 'black'}}>
                    About
                  </Typography>
                </Link>
              </MenuItem> 
              <MenuItem onClick={handleCloseNavMenu}>
                <Link to="https://www.givesendgo.com/stopgenderideology" target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                  <Typography textAlign="center" sx={{ color: 'black'}}>
                      Donate
                  </Typography>
                </Link>
              </MenuItem>          
            </Menu>
          </Box>

          <Box
                component="img"
                sx={{mr: 2, height: 40,  display: { xs: 'flex', md: 'none' } }}
                alt="Your logo."
                src={logo}
            />

          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
              <Link to="/" style={{ textDecoration: 'none' }}>
                <Button
                  onClick={handleCloseNavMenu}
                  sx={{ my: 2, color: 'black', display: 'block' }}
                >
                  Home
                </Button>
              </Link>
              <Link to="/Story" style={{ textDecoration: 'none' }}>
                <Button
                  onClick={handleCloseNavMenu}
                  sx={{ my: 2, color: 'black', display: 'block' }}
                >
                  Our Story
                </Button>
              </Link>
              <Link to="https://www.ArtCLubMovie.com" target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                <Button
                  onClick={handleCloseNavMenu}
                  sx={{ my: 2, color: 'black', display: 'block' }}
                >
                  Documentary
                </Button>
              </Link>
              <Link to="/Resources" style={{ textDecoration: 'none' }}>
                <Button
                  onClick={handleCloseNavMenu}
                  sx={{ my: 2, color: 'black', display: 'block' }}
                >
                  Resources
                </Button>
              </Link>
              <Link to="/RapidOnset" style={{ textDecoration: 'none' }}>
                <Button
                  onClick={handleCloseNavMenu}
                  sx={{ my: 2, color: 'black', display: 'block' }}
                >
                  ROGD
                </Button>
              </Link>
              <Link to="/Connect" style={{ textDecoration: 'none' }}>
                <Button
                  onClick={handleCloseNavMenu}
                  sx={{ my: 2, color: 'black', display: 'block' }}
                >
                  Connect
                </Button>
              </Link>
              <Link to="/About" style={{ textDecoration: 'none' }}>
                <Button
                  onClick={handleCloseNavMenu}
                  sx={{ my: 2, color: 'black', display: 'block' }}
                >
                  About
                </Button>
              </Link>
              <Link to="https://www.givesendgo.com/stopgenderideology" target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                <Button
                  onClick={handleCloseNavMenu}
                  sx={{ my: 2, color: 'black', display: 'block' }}
                >
                  Donate
                </Button>
              </Link>

          </Box>

        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;
